import ReactCountryFlag from 'react-country-flag';

import { CountriesWithISOCodes } from '@/utils/intl';

const FLAG_CDN_URL = 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/';

const DEFAULT_STYLE: React.CSSProperties = {
    height: 13,
    width: 24,
};

type Props = {
    className?: string;
    countryCode?: string;
    style?: React.CSSProperties;
};

export const Flag = ({ className, countryCode = 'US', style = DEFAULT_STYLE }: Props) => {
    let code = countryCode.toUpperCase();

    if (code === 'UK') {
        code = 'GB';
    }

    const name =
        CountriesWithISOCodes.find((country) => country.code === code)?.name ??
        CountriesWithISOCodes.find((country) => country.code === 'US')?.name ??
        'United States';

    if (!CountriesWithISOCodes.some((country) => country.code === code)) {
        code = 'US';
    }

    return (
        <ReactCountryFlag
            alt={name}
            aria-label={name}
            cdnUrl={FLAG_CDN_URL}
            className={className}
            countryCode={code}
            style={style}
            svg
        />
    );
};
